export enum ReCaptchaAction {
  LOGIN = 'login',
  REGISTER = 'signup',
  PASSWORD_RECOVER = 'custom_password_reset',
  SMS_REQUEST = 'custom_sms',
}
